<script setup lang="ts">
import { DocumentTextIcon, ExclamationCircleIcon } from '@heroicons/vue/solid'
import {
    AccountNavigationStore,
    navigateTo,
    useAccountNavigationState,
} from '../../../utilities/account/useAccountNavigationPersonal'
import { usePersonalAccountDataState } from '../../../utilities/account/useAccountDataPersonal'
import { i18n } from '../../../localization'
import Alert from '../../base/Alert.vue'

const personalAccountState = usePersonalAccountDataState()
const navigationState = useAccountNavigationState() as AccountNavigationStore
</script>

<template>
    <Alert
        :title-text="i18n.global.t('signatures.pending_signatures')"
        :description-text="i18n.global.t('signatures.pending_signatures_description')"
        :show-button="
            personalAccountState.naturalProfile.signatures.length > 0 &&
            personalAccountState.naturalProfile.signatures.filter((signature) => signature.signed_at === null).length >
                0 &&
            navigationState.page !== 'Signatures'
        "
        :button-text="i18n.global.t('signatures.sign_documents')"
        @click-button="navigateTo('Signatures')">
        <template #icon>
            <DocumentTextIcon class="h-12 w-12 text-gray-300"></DocumentTextIcon>
            <ExclamationCircleIcon
                class="absolute bottom-0 right-[-5px] h-6 w-6 rounded-full bg-white text-red-400"></ExclamationCircleIcon>
        </template>
    </Alert>
</template>

<style scoped></style>
